import { AuthLoadingState } from '../AuthLoadingState'
import { TableCell, TableRow } from './table'

export function TableLoadingState({
  colSpan,
  label = 'Loading...',
}: {
  colSpan: number
  label?: string
}) {
  return (
    <TableRow className="hover:bg-transparent">
      <TableCell colSpan={colSpan} className="py-16">
        <AuthLoadingState label={label} compact />
      </TableCell>
    </TableRow>
  )
}
